import * as React from "react"
import {
  Button,
  Flex,
  Heading,
  Stack,
  Text,
  ListItem,
  UnorderedList,
  Link,
  Box
} from '@chakra-ui/react';
import {
  Link as GatsbyLink,
} from 'gatsby';

export default function Hero() {
  return (
    <Stack className="hero" direction={{ base: 'column', xl: 'row' }} spacing="20px">
      <Flex p={4} flex={1} align={'center'} justify={'center'}>
        <Stack spacing={6} w={'full'} maxW={'lg'}>
          <Heading className="hero__title" fontSize={{ base: '3xl', md: '4xl', lg: '42px' }}>
            <Text as={'span'}>
              Jameson Moving & Storage LLC
            </Text>{' '}
          </Heading>
          <Text className="hero__subTitle" fontSize={{ base: 'lg', lg: 'xl' }}>
            No job is too big or too small.
          </Text>
          <Box className="hero__list" fontSize={{ base: 'md', lg: 'lg' }}>
            <UnorderedList>
              <ListItem>Fully Licensed and Insured</ListItem>
              <ListItem>Long Distance Moving</ListItem>
              <ListItem>Free in Home / Office Estimates</ListItem>
              <ListItem>Last Minute Moves</ListItem>
              <ListItem>Full or Partial Packing</ListItem>
              <ListItem>Cleanouts</ListItem>
              <ListItem>24/7 Self Storage</ListItem>
              <ListItem>Furniture Disassembly / Assembly</ListItem>
              <ListItem>Ask about our on-time guarantee!</ListItem>
            </UnorderedList>
          </Box>
          {/*<Text className="hero__text" fontSize={{ base: 'md', lg: 'lg' }}>
            Serving all 48 contiguous US states.
          </Text>*/}
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Button
              p={"22px 25px"}
              fontFamily={'PoppinsMedium, sans-serif, serif'}
              fontWeight={'normal'}
              fontSize={'lg'}
              rounded={'full'}
              bg={'#7B4B94'}
              color={'white'}
              _hover={{
                bg: '#582e6e',
              }}>
              <Link as={GatsbyLink} to='/contact' _hover={{textDecoration: 'none'}}>Get a Quote</Link>
            </Button>
          </Stack>
        </Stack>
      </Flex>
      <Flex p={4} flex={1} display={{ base: 'none', xl: 'flex' }}>
        <Stack className="hero__image_wrapper">
        </Stack>
      </Flex>
    </Stack>
  );
}